import { useEffect, useState } from 'react';

export default function useOneTrust() {
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        // OneTrust SDK may load asynchronously after the component mounts
        if (window.OneTrust) {
            setIsEnabled(true);
            return;
        }

        const observer = new MutationObserver(() => {
            if (window.OneTrust) {
                setIsEnabled(true);
                observer.disconnect();
            }
        });

        observer.observe(document.head, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, []);

    return isEnabled;
}
